import {
  Checkbox,
  type CheckboxProps,
  FormControlLabel,
  type FormControlLabelProps,
} from "@mui/material"
import { Controller, type FieldPath, type FieldValues } from "react-hook-form"
import { useFieldRoleConf } from "../../../context"

export type FormCheckboxFieldProps<TFieldValues extends FieldValues = FieldValues> =
  {
    name: FieldPath<TFieldValues>
    label?: string
    labelPlacement?: FormControlLabelProps["labelPlacement"]
  } & CheckboxProps

export const FormCheckboxField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  label = "",
  labelPlacement = "end",
  ...otherProps
}: FormCheckboxFieldProps<TFieldValues>) => {
  const fieldConf = useFieldRoleConf(name)

  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPlacement}
      control={
        <Controller
          name={name}
          render={({ field: { value, onChange, ...field } }) => (
            <Checkbox
              {...field}
              {...otherProps}
              {...fieldConf}
              checked={!!value}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      }
    />
  )
}
